import { EMAIL_REGEX, GENERAL_FORM_CONSTANTS } from "src/forms/constants";
import { CUSTOM_VALIDATION_TYPES, FormValidationType } from "../../../../types";
import { ADDITIONAL_INFORMATION_CONSTANTS } from "../../../constants";

export const formFieldsValidation: FormValidationType = {
  [ADDITIONAL_INFORMATION_CONSTANTS.INSTALLATION_SOURCE]: {
    required: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.PRODUCT_LINK]: {
    required: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ERC_OFFER_AMOUNT]: {
    required: { value: true },
    allowedCharactersRegExp: {
      value: new RegExp(GENERAL_FORM_CONSTANTS.CURRENCY_REGEX),
    },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ITEM_RETURNED]: {
    required: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.AMAZON_LOCATION]: {
    required: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.RETURN_CENTER_POC]: {
    required: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ADVISED_DISPOSAL]: {
    required: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.SELLER_CONTACT_DETAILS]: {
    required: { value: false },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ADDRESS_LINE_1]: {
    required: { value: false },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.ADDRESS_LINE_2]: {
    required: { value: false },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.CITY]: {
    required: { value: false },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.COUNTRY]: {
    required: { value: false },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.PHONE]: {
    required: { value: false },
    [CUSTOM_VALIDATION_TYPES.E164_PHONE_FORMAT]: { value: true },
    maxCharacters: { value: 16 }, // E.164 max is 15 digits + 1 for the + sign
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.EMAIL]: {
    required: { value: false },
    matchRegExp: {
      value: new RegExp(EMAIL_REGEX),
      message: GENERAL_FORM_CONSTANTS.EMAIL_INVALID_MESSAGE,
    },
    [CUSTOM_VALIDATION_TYPES.REMOVE_WHITE_SPACE]: { value: true },
  },
  [ADDITIONAL_INFORMATION_CONSTANTS.REPORTED_TO_PR]: {
    required: { value: true },
  },
};
